import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModuleComponent } from './module/module.component';
import { ModuleDetailsComponent } from './module-details/module-details.component';
import { ModulesListComponent } from './modules-list/modules-list.component';
import { ModulesRoutingModule } from './modules-routing.module';

@NgModule({
  imports: [
    CommonModule,
    ModulesRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    ModulesListComponent,
    ModuleComponent,
    ModuleDetailsComponent
  ],
  entryComponents: [
    ModuleComponent,
    ModuleDetailsComponent
  ]
})
export class ModulesModule {
}
